var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "vks-ge-drawer" }, [
    _c("p", { staticClass: "vks-ui-intro" }, [
      _vm._v(
        " Global enrichment and regulatory annotations for the searched phenotype and locus. "
      ),
    ]),
    _vm.loading && !_vm.hideLoadingStatus
      ? _c("div", { staticClass: "vks-ui-status" }, [
          _vm._v(" Loading global enrichment… "),
        ])
      : _vm.error
      ? _c("div", { staticClass: "vks-ui-error", attrs: { role: "alert" } }, [
          _vm._v(" " + _vm._s(_vm.error) + " "),
        ])
      : _vm.hasAnnoData
      ? _c("div", { staticClass: "vks-ge-drawer-body" }, [
          _c(
            "section",
            { staticClass: "vks-drawer-section vks-drawer-section--controls" },
            [
              _c(
                "div",
                {
                  staticClass: "vks-ui-tabs",
                  attrs: {
                    role: "tablist",
                    "aria-label": "Global enrichment panels",
                  },
                },
                _vm._l(_vm.tabs, function (tab) {
                  return _c(
                    "button",
                    {
                      key: tab.id,
                      staticClass: "vks-ui-tab",
                      class: { "is-active": _vm.activeTab === tab.id },
                      attrs: {
                        id: `vks-ge-tab-${tab.id}`,
                        type: "button",
                        role: "tab",
                        "aria-selected":
                          _vm.activeTab === tab.id ? "true" : "false",
                        "aria-controls": `vks-ge-panel-${tab.id}`,
                      },
                      on: {
                        click: function ($event) {
                          _vm.activeTab = tab.id
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(tab.label) + " ")]
                  )
                }),
                0
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.activeTab === "tissues",
                      expression: "activeTab === 'tissues'",
                    },
                  ],
                  staticClass: "vks-ui-tab-panel",
                  attrs: {
                    id: "vks-ge-panel-tissues",
                    role: "tabpanel",
                    "aria-labelledby": "vks-ge-tab-tissues",
                  },
                },
                [
                  _c("p", { staticClass: "vks-ui-hint" }, [
                    _vm._v(
                      " All tissues available for each annotation. Checked tissues are shown on that annotation track. Reset restores the initial CS2CT / p-value selection. "
                    ),
                  ]),
                  _vm.mutedAnnotationOptions.length
                    ? _c("div", { staticClass: "vks-ge-muted-group" }, [
                        _c("p", { staticClass: "vks-ui-section-title" }, [
                          _vm._v("Muted annotation types"),
                        ]),
                        _c("p", { staticClass: "vks-ui-hint" }, [
                          _vm._v(
                            " These annotation types were filtered out. Check to show them again. "
                          ),
                        ]),
                        _c(
                          "ul",
                          { staticClass: "vks-ge-muted-list" },
                          _vm._l(
                            _vm.mutedAnnotationOptions,
                            function (annotation) {
                              return _c(
                                "li",
                                {
                                  key: annotation,
                                  staticClass: "vks-ge-muted-item",
                                },
                                [
                                  _c("label", [
                                    _c("input", {
                                      attrs: { type: "checkbox" },
                                      domProps: {
                                        checked:
                                          _vm.enabledMutedAnnotations.includes(
                                            annotation
                                          ),
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.onToggleMutedAnnotation(
                                            annotation,
                                            $event
                                          )
                                        },
                                      },
                                    }),
                                    _c("span", [_vm._v(_vm._s(annotation))]),
                                  ]),
                                ]
                              )
                            }
                          ),
                          0
                        ),
                      ])
                    : _vm._e(),
                  _vm.tissueGroups.length
                    ? _c("div", [
                        _c("div", { staticClass: "vks-ge-tissue-toolbar" }, [
                          _c(
                            "label",
                            { staticClass: "vks-ge-annotation-select" },
                            [
                              _c(
                                "span",
                                { staticClass: "vks-ge-track-sort-label" },
                                [_vm._v("Annotation")]
                              ),
                              _c(
                                "select",
                                {
                                  staticClass: "vks-ge-track-sort-select",
                                  attrs: {
                                    "aria-label":
                                      "Annotation for tissue filters",
                                  },
                                  domProps: {
                                    value: _vm.activeTissueAnnotation,
                                  },
                                  on: { change: _vm.onTissueAnnotationChange },
                                },
                                _vm._l(_vm.tissueGroups, function (group) {
                                  return _c(
                                    "option",
                                    {
                                      key: group.annotation,
                                      domProps: { value: group.annotation },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.annotationDropdownLabel(group)
                                          ) +
                                          " "
                                      ),
                                    ]
                                  )
                                }),
                                0
                              ),
                            ]
                          ),
                          _c(
                            "button",
                            {
                              staticClass: "vks-ui-btn vks-ui-btn--secondary",
                              attrs: { type: "button" },
                              on: { click: _vm.onResetTissueSelection },
                            },
                            [_vm._v(" Reset ")]
                          ),
                        ]),
                        _vm.activeTissueGroup
                          ? _c("div", { staticClass: "vks-ge-tissue-panel" }, [
                              _c(
                                "label",
                                { staticClass: "vks-ge-tissue-select-all" },
                                [
                                  _c("input", {
                                    attrs: {
                                      type: "checkbox",
                                      "aria-label": `Select all tissues for ${_vm.activeTissueGroup.annotation}`,
                                    },
                                    domProps: {
                                      checked: _vm.activeTissueGroup.allShown,
                                      indeterminate:
                                        _vm.activeTissueGroup.someShown &&
                                        !_vm.activeTissueGroup.allShown,
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.onSelectAllTissuesForAnnotation(
                                          _vm.activeTissueGroup.annotation,
                                          $event
                                        )
                                      },
                                    },
                                  }),
                                  _c("span", [_vm._v("Select all")]),
                                ]
                              ),
                              _c(
                                "ul",
                                {
                                  staticClass: "vks-ge-tissue-list",
                                  attrs: {
                                    role: "group",
                                    "aria-label": `Tissues for ${_vm.activeTissueGroup.annotation}`,
                                  },
                                },
                                _vm._l(
                                  _vm.activeTissueGroup.tissues,
                                  function (tissue) {
                                    return _c(
                                      "li",
                                      {
                                        key: `${_vm.activeTissueGroup.annotation}:::${tissue}`,
                                        staticClass: "vks-ge-tissue-item",
                                      },
                                      [
                                        _c(
                                          "label",
                                          {
                                            staticClass: "vks-ge-tissue-check",
                                          },
                                          [
                                            _c("input", {
                                              attrs: { type: "checkbox" },
                                              domProps: {
                                                checked:
                                                  _vm.isTissueShownForAnnotation(
                                                    _vm.activeTissueGroup
                                                      .annotation,
                                                    tissue
                                                  ),
                                              },
                                              on: {
                                                change: function ($event) {
                                                  return _vm.onToggleAnnotationTissue(
                                                    _vm.activeTissueGroup
                                                      .annotation,
                                                    tissue,
                                                    $event
                                                  )
                                                },
                                              },
                                            }),
                                            _c("span", [
                                              _vm._v(_vm._s(tissue)),
                                            ]),
                                          ]
                                        ),
                                      ]
                                    )
                                  }
                                ),
                                0
                              ),
                            ])
                          : _vm._e(),
                      ])
                    : _c("p", { staticClass: "vks-ui-hint" }, [
                        _vm._v(
                          " No tissues are available for the current annotations. "
                        ),
                      ]),
                ]
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.activeTab === "settings",
                      expression: "activeTab === 'settings'",
                    },
                  ],
                  staticClass: "vks-ui-tab-panel",
                  attrs: {
                    id: "vks-ge-panel-settings",
                    role: "tabpanel",
                    "aria-labelledby": "vks-ge-tab-settings",
                  },
                },
                [
                  _c("section", { staticClass: "vks-ui-section" }, [
                    _c("p", { staticClass: "vks-ui-section-title" }, [
                      _vm._v("Filters"),
                    ]),
                    _c("label", { staticClass: "vks-ge-pvalue-filter" }, [
                      _c("span", { staticClass: "vks-ge-track-sort-label" }, [
                        _vm._v("P-value"),
                      ]),
                      _c("input", {
                        staticClass: "vks-ge-pvalue-input",
                        attrs: {
                          type: "text",
                          inputmode: "decimal",
                          "aria-label":
                            "Maximum enrichment p-value for tissues shown on tracks",
                        },
                        domProps: { value: _vm.pValueInput },
                        on: {
                          input: _vm.onPValueInput,
                          change: _vm.onPValueCommit,
                          blur: _vm.onPValueCommit,
                        },
                      }),
                    ]),
                    _c("div", { staticClass: "vks-ge-filter-group" }, [
                      _c("p", { staticClass: "vks-ge-track-sort-label" }, [
                        _vm._v("Methods"),
                      ]),
                      _c(
                        "ul",
                        {
                          staticClass: "vks-ge-tissue-list",
                          attrs: { role: "group", "aria-label": "Methods" },
                        },
                        _vm._l(_vm.methodOptions, function (method) {
                          return _c(
                            "li",
                            {
                              key: `method-${method}`,
                              staticClass: "vks-ge-tissue-item",
                            },
                            [
                              _c(
                                "label",
                                { staticClass: "vks-ge-tissue-check" },
                                [
                                  _c("input", {
                                    attrs: { type: "checkbox" },
                                    domProps: {
                                      checked: _vm.isMethodSelected(method),
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.onToggleMethod(
                                          method,
                                          $event
                                        )
                                      },
                                    },
                                  }),
                                  _c("span", [_vm._v(_vm._s(method))]),
                                ]
                              ),
                            ]
                          )
                        }),
                        0
                      ),
                    ]),
                    _c("div", { staticClass: "vks-ge-filter-group" }, [
                      _c("p", { staticClass: "vks-ge-track-sort-label" }, [
                        _vm._v("Sources"),
                      ]),
                      _c(
                        "ul",
                        {
                          staticClass: "vks-ge-tissue-list",
                          attrs: { role: "group", "aria-label": "Sources" },
                        },
                        _vm._l(_vm.sourceOptions, function (source) {
                          return _c(
                            "li",
                            {
                              key: `source-${source}`,
                              staticClass: "vks-ge-tissue-item",
                            },
                            [
                              _c(
                                "label",
                                { staticClass: "vks-ge-tissue-check" },
                                [
                                  _c("input", {
                                    attrs: { type: "checkbox" },
                                    domProps: {
                                      checked: _vm.isSourceSelected(source),
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.onToggleSource(
                                          source,
                                          $event
                                        )
                                      },
                                    },
                                  }),
                                  _c("span", [_vm._v(_vm._s(source))]),
                                ]
                              ),
                            ]
                          )
                        }),
                        0
                      ),
                    ]),
                  ]),
                  _c("section", { staticClass: "vks-ui-section" }, [
                    _c("p", { staticClass: "vks-ui-section-title" }, [
                      _vm._v("Settings"),
                    ]),
                    _c("label", { staticClass: "vks-ge-track-sort" }, [
                      _c("span", { staticClass: "vks-ge-track-sort-label" }, [
                        _vm._v("Sort tracks in:"),
                      ]),
                      _c(
                        "select",
                        {
                          staticClass: "vks-ge-track-sort-select",
                          attrs: { "aria-label": "Sort tracks in" },
                          domProps: { value: _vm.tissueTrackSort },
                          on: { change: _vm.onTissueTrackSortChange },
                        },
                        _vm._l(_vm.tissueTrackSortOptions, function (option) {
                          return _c(
                            "option",
                            { key: option.id, domProps: { value: option.id } },
                            [_vm._v(" " + _vm._s(option.label) + " ")]
                          )
                        }),
                        0
                      ),
                    ]),
                  ]),
                ]
              ),
            ]
          ),
          _c(
            "section",
            { staticClass: "vks-drawer-section vks-drawer-section--table" },
            [
              _vm.tableAnnotationTabs.length
                ? _c("div", { staticClass: "vks-ge-table-toolbar" }, [
                    _c("label", { staticClass: "vks-ge-annotation-select" }, [
                      _c("span", { staticClass: "vks-ge-track-sort-label" }, [
                        _vm._v("Annotation"),
                      ]),
                      _c(
                        "select",
                        {
                          staticClass: "vks-ge-track-sort-select",
                          attrs: { "aria-label": "Annotation for data tables" },
                          domProps: { value: _vm.activeTableAnnotation },
                          on: { change: _vm.onTableAnnotationChange },
                        },
                        _vm._l(_vm.tableAnnotationTabs, function (annotation) {
                          return _c(
                            "option",
                            {
                              key: annotation,
                              domProps: { value: annotation },
                            },
                            [_vm._v(" " + _vm._s(annotation) + " ")]
                          )
                        }),
                        0
                      ),
                    ]),
                  ])
                : _c("p", { staticClass: "vks-ui-hint" }, [
                    _vm._v(
                      " No annotation plot tissues are available for the table. "
                    ),
                  ]),
              _vm.activeTableAnnotation
                ? _c("div", { staticClass: "vks-ge-table-section" }, [
                    _c(
                      "div",
                      { staticClass: "vks-ge-table-panel" },
                      [
                        _c("p", { staticClass: "vks-ui-section-title" }, [
                          _vm._v("Global enrichment"),
                        ]),
                        _c("VariantSifterGlobalEnrichmentTable", {
                          attrs: { rows: _vm.geTableRows, utils: _vm.utils },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "vks-ge-table-panel" },
                      [
                        _c("p", { staticClass: "vks-ui-section-title" }, [
                          _vm._v("Enriched regions"),
                        ]),
                        _c("VariantSifterEnrichedRegionsTable", {
                          attrs: {
                            rows: _vm.enrichedRegionsRows,
                            utils: _vm.utils,
                          },
                        }),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
            ]
          ),
        ])
      : _c("p", { staticClass: "vks-ui-hint" }, [
          _vm._v(" No regulatory annotations were found for this locus. "),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }